import React, { useEffect, useState, useContext, useMemo } from 'react';

import { Container, PageContainer, PageTitle } from '../styles';

import NavbarSindico from '../NavbarSindico/index';

import { ButtonPrimary, Spinner } from '../../../Components/StyledComponent';

import Paginacao from '../../../Components/Paginacao';

import loadSindico from '../loadSindico';

import { useHistory } from 'react-router-dom';
import NenhumaSolicitacaoCriada from './NenhumaSolicitacaoCriada';

import { ContextSindico } from '../../../services/sindico';

import DropDown from '../../../Components/Reutilizaveis/DropDown';

export default function SolicitacoesSindico() {
  const [filtroPorStatus, setFiltroPorStatus] = useState('Todos');
  const [solicitacoesParaExibir, setSolicitacoesParaExibir] = useState([]);

  const history = useHistory();

  const {
    getSolicitacoes,
    tema,
    empreendimentoSelecionado,
    setEmpreedimentoSelecionado,
    logoutSindico,
  } = useContext(ContextSindico);

  const [solicitacoes, setSolicitacoes] = useState([]);
  const [isLoadingSolicitacoes, setIsLoadingSolicitacoes] = useState(true);

  function redirectToNewSolicitation() {
    history.push('/sindico/nova-solicitacao');
  }

  useEffect(() => {
    if (!loadSindico()) {
      logoutSindico();
    }

    empreendimentosSindico?.length > 0 &&
      setEmpreedimentoSelecionado(
        empreendimentosSindico[0]?.nomeEmpreendimento
      );
  }, []);

  useEffect(() => {
    (async function () {
      if (empreendimentoSelecionado) {
        setIsLoadingSolicitacoes(true);
        const empreendimento = findEmpreendimentoByName(
          empreendimentoSelecionado
        );
        const responseSolicitacoes = await getSolicitacoes(
          empreendimento?.empreendimentoId
        );
        setSolicitacoes(responseSolicitacoes);
        setIsLoadingSolicitacoes(false);
      }
    })();
  }, [empreendimentoSelecionado]);

  useEffect(() => {
    if (filtroPorStatus.includes('Todos'))
      setSolicitacoesParaExibir(solicitacoes);
    else {
      let solicitacoesFiltradasPorStatus = solicitacoes.filter((solicitacao) =>
        filtroPorStatus.includes(solicitacao.status)
      );
      setSolicitacoesParaExibir(solicitacoesFiltradasPorStatus);
    }
  }, [solicitacoes, filtroPorStatus]);

  const empreendimentosSindico = useMemo(() => {
    const sindicoInfos = loadSindico();

    if (
      sindicoInfos?.empreendimentos &&
      sindicoInfos?.empreendimentos?.length > 0
    ) {
      return sindicoInfos?.empreendimentos?.map((empreendimento) => {
        return { ...empreendimento, nome: empreendimento.nomeEmpreendimento };
      });
    }
  }, []);

  const findEmpreendimentoByName = (name) => {
    if (empreendimentosSindico && empreendimentosSindico?.length > 0) {
      return empreendimentosSindico.find(
        (empreendimento) => empreendimento.nomeEmpreendimento === name
      );
    }
  };

  return (
    <PageContainer>
      <NavbarSindico />
      <Container>
        <PageTitle tema={tema}>Acompanhamento de solicitações</PageTitle>
        <DropDown
          itens={empreendimentosSindico}
          idDropDown={'Listaimoveis'}
          setValue={setEmpreedimentoSelecionado}
          label='Selecione o empreendimento'
          nomeDropDown='SELECIONE O EMPREENDIMENTO'
          overflow='hidden'
          alturaMinima='120px'
          widthMeuImovel='100%'
          marginLeftMeuImovel='0px'
          obrigatorio='true'
          nomeSelecionado={empreendimentoSelecionado}
          marginTop={50}
          marginBottom={50}
        />
        {empreendimentoSelecionado && isLoadingSolicitacoes && (
          <Spinner style={{ margin: 'auto' }} />
        )}
        {!isLoadingSolicitacoes && solicitacoes.length > 0 && (
          <>
            <p>
              Veja abaixo as suas solicitações criadas e clique no botão caso
              queira criar uma nova solicitação:
            </p>
            <ButtonPrimary
              tema={tema}
              fullWidth
              onClick={redirectToNewSolicitation}
              style={{ margin: '24px auto' }}
              disabled={isLoadingSolicitacoes}
              id='btnCriarNovaSolicitacao'
            >
              Criar nova solicitação
            </ButtonPrimary>

            <Paginacao
              parcelas={solicitacoesParaExibir}
              tema={tema}
              tipo='solicitacoes'
              setFiltroPorStatus={setFiltroPorStatus}
              filtroPorStatus={filtroPorStatus}
              isSindico
            />
          </>
        )}
        {empreendimentoSelecionado &&
          !isLoadingSolicitacoes &&
          !solicitacoes?.length > 0 && (
            <NenhumaSolicitacaoCriada
              functionOnClickNewSolicitation={redirectToNewSolicitation}
            />
          )}
      </Container>
    </PageContainer>
  );
}
